import { CoreActionsEnum } from '../enums/CoreActionsEnum';
import { ICoreState } from '../interfaces/ICoreState';
import { CoreAction } from '../types/CoreAction';

const initialState: ICoreState = {
  loading: 0,
  screenSize: 'desktop',
  height: 0,
};

export function coreReducer(state = initialState, action: CoreAction): ICoreState {
  switch (action.type) {
    case CoreActionsEnum.CORE_SET_LOADING: {
      let { loading } = state;
      if (action.payload.value) {
        loading += 1;
      } else if (loading !== 0) {
        loading -= 1;
      }
      const newState = {
        ...state,
        loading,
      };
      return newState;
    }
    case CoreActionsEnum.CORE_SHOW_NOTICE:
      return {
        ...state,
        noticeType: action.payload.noticeType,
        notice: action.payload.notice,
        isShowNotice: true,
      };
    case CoreActionsEnum.CORE_HIDE_NOTICES:
      return {
        ...state,
        isShowNotice: false,
      };
    case CoreActionsEnum.CORE_CHANGE_VIEW:
      return {
        ...state,
        screenSize: action.payload.screenSize,
      };
    case CoreActionsEnum.CORE_SET_HEADER_HEIGHT:
      return {
        ...state,
        height: action.payload.height,
      };
    case CoreActionsEnum.CORE_SET_LOGIN_PAGE:
      return {
        ...state,
        loginPageUrl: action.payload.loginPageUrl,
      };
    default:
      return state;
  }
}
